import PropTypes from "prop-types";
import React from "react";

export const Email = (props) => {
  const { className, role, size, style } = props;

  return (
    <svg {...getProps()}>
      <path strokeWidth={0} d="M29.07 7.21 L3.15 7.21 L16.13 15.21 L29.07 7.21 Z" />
      <path d="M16.16,17.8l-14-8.59v11a3,3,0,0,0,3,3h22a3,3,0,0,0,3-3V9.27Z" />
    </svg>
  );

  function getProps() {
    return {
      "aria-label": props["aria-label"],
      className,
      height: size,
      role,
      style,
      viewBox: "0 0 32 32",
    };
  }
};

Email.displayName = "EmailIcon";

Email.propTypes = {
  /** aria-label text to provide accessibility description for this SVG element. */
  "aria-label": PropTypes.string,

  /**
   * Additional classes for positioning the component. Given classes may only position this component for layout
   * purposes, and cannot change how the component renders in any way.
   */
  className: PropTypes.string,

  /**
   * custom allows for component to implement styling for a specific characteristic. There is no obligation for a
   * component to implement the custom prop.
   */
  custom: PropTypes.object,

  /** Name used for aria role. */
  role: PropTypes.string,

  /** Indicates icon's height. The width will be sized accordion to SVG's aspect ratio. */
  size: PropTypes.string,

  /**
   * CSS object to applied to SVG element. Currently, style is expected to only define stroke and fill color, but
   * there is not such a restriction or requirement at this time.
   */
  style: PropTypes.object,
};

Email.defaultProps = {
  role: "img",
};
